import api from './config';

/**
 * 获取歌单列表
 * @param {Object} params 查询参数
 */
export function getPlaylists(params = {}) {
  return api.get('/playlists', { params });
}

/**
 * 获取歌单详情
 * @param {string} id 歌单ID
 */
export function getPlaylistById(id) {
  return api.get(`/playlists/${id}`);
}

/**
 * 创建歌单
 * @param {Object} data 歌单数据
 */
export function createPlaylist(data) {
  return api.post('/playlists', data);
}

/**
 * 更新歌单
 * @param {string} id 歌单ID
 * @param {Object} data 歌单数据
 */
export function updatePlaylist(id, data) {
  return api.put(`/playlists/${id}`, data);
}

/**
 * 删除歌单
 * @param {string} id 歌单ID
 */
export function deletePlaylist(id) {
  return api.delete(`/playlists/${id}`);
}

/**
 * 获取歌单设备访问权限
 * @param {string} deviceId 设备ID
 */
export function getPlaylistDeviceAccess(deviceId) {
  return api.get('/playlist_device_access', { params: { device_id: deviceId } });
}

/**
 * 授权设备访问歌单
 * @param {Object} data {playlist_id, device_id}
 */
export function grantPlaylistAccess(data) {
  return api.post('/playlist_device_access', data);
}

/**
 * 取消授权
 * @param {string} id 授权ID
 */
export function revokePlaylistAccess(id) {
  return api.delete(`/playlist_device_access/${id}`);
} 

/**
 * 获取账号授权的歌单列表
 * @param {number} userId} userId 用户ID（可选，默认查询当前用户）
 */
export function getPlaylistAccountAccess(userId = null) {
  const params = userId ? { user_id: userId } : {};
  return api.get('/playlist_account_access', { params });
}

/**
 * 授权歌单给用户账号
 * @param {Object} data {playlist_id, user_id}
 */
export function grantPlaylistToAccount(data) {
  return api.post('/playlist_account_access', data);
}

/**
 * 取消账号授权
 * @param {string} id 授权记录ID
 */
export function revokePlaylistAccountAccess(id) {
  return api.delete(`/playlist_account_access/${id}`);
}

/**
 * 批量授权歌单给所有用户（管理员）
 * @param {string} playlistId 歌单ID
 */
export function grantPlaylistToAllAccounts(playlistId) {
  return api.post('/playlist_account_access/grant-all', { playlist_id: playlistId });
}

/**
 * 获取歌单类别列表（用于歌单编辑下拉）
 */
export function getPlaylistCategories() {
  return api.get('/playlist_categories');
}

/**
 * 获取标签列表（用于歌单编辑多选）
 */
export function getTags() {
  return api.get('/tags');
}

/**
 * 歌单类别 CRUD（管理员）
 */
export function createPlaylistCategory(data) {
  return api.post('/playlist_categories', data);
}
export function updatePlaylistCategory(id, data) {
  return api.put(`/playlist_categories/${id}`, data);
}
export function deletePlaylistCategory(id) {
  return api.delete(`/playlist_categories/${id}`);
}

/**
 * 标签 CRUD（管理员）
 */
export function createTag(data) {
  return api.post('/tags', data);
}
export function updateTag(id, data) {
  return api.put(`/tags/${id}`, data);
}
export function deleteTag(id) {
  return api.delete(`/tags/${id}`);
} 